import log from 'loglevel'
import { isNil } from 'lodash/fp'
import { type fetchUtils } from 'react-admin'

import {
  CognitoUserPool,
  type CognitoUserSession
} from 'amazon-cognito-identity-js'

import cognito from '../../../../cdk/bapp/lib/lambda-api/src/cognito.json'

const env = process.env['ENV'] as string
const { userPoolId: UserPoolId, clientId: ClientId } =
  cognito[env as keyof typeof cognito]
const userPool = new CognitoUserPool({
  UserPoolId,
  ClientId
})
export const url = !isNil(process.env['API_LOCAL'])
  ? 'http://localhost:14001/v1'
  : {
      prd: 'https://api.bapp.terashite.jp/v1',
      stg: 'https://api-stg.bapp.terashite.jp/v1',
      int: 'https://api-int.bapp.dev.terashite.jp/v1',
      dev: 'https://api-dev.bapp.terashite.jp/v1',
      exp: 'https://api-exp.bapp.dev.terashite.jp/v1'
    }[env]
log.setLevel(log.levels.DEBUG)

export const getCustomHeaders = (
  options: fetchUtils.Options = {},
  partner: string | undefined
): Headers | undefined => {
  const cognitoUser = userPool.getCurrentUser()
  if (isNil(cognitoUser)) return undefined
  let session: any
  cognitoUser.getSession(
    (error: Error, newSession: CognitoUserSession | null) => {
      if (!isNil(error)) {
        log.error('[DataProvider.fetchJson]', { error })
        return
      }
      session = newSession
    }
  )
  if (isNil(session)) return undefined
  const customHeaders = (
    !isNil(options.headers)
      ? options.headers
      : new Headers({
          Accept: 'application/json'
        })
  ) as Headers
  customHeaders.set('Authorization', session.getIdToken().getJwtToken())
  if (!isNil(partner)) {
    customHeaders.set('X-Partner', partner)
  }
  return customHeaders
}
